import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBreakpoint } from '../hooks/useBreakpoint';

export default function PromoBanner() {
  const navigate = useNavigate();
  const { isMobile } = useBreakpoint();

  return (
    <div style={{
      background: 'linear-gradient(90deg, #D4A017 0%, #8B1A1A 100%)',
      padding: isMobile ? '32px 20px' : '40px 24px',
      textAlign: 'center',
    }}>
      <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 8 }}>
        Limited Time Offer
      </p>
      <h2 style={{
        fontFamily: "'Playfair Display', serif",
        fontSize: 'clamp(24px, 4vw, 40px)',
        color: '#fff',
        marginBottom: 12,
      }}>
        Get 20% Off Your First Order
      </h2>
      <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 15, marginBottom: 24 }}>
        Use code <strong>WELCOME20</strong> at checkout
      </p>
      <button
        onClick={() => navigate('/shop')}
        style={{
          background: '#fff',
          color: '#8B1A1A',
          border: 'none',
          padding: '12px 32px',
          fontSize: 14,
          fontWeight: 700,
          borderRadius: 4,
          cursor: 'pointer',
          letterSpacing: 0.5,
        }}
      >
        Shop Now
      </button>
    </div>
  );
}
